<div class="pl-root" [class.pl-compacto]="compacto">

  <!-- ========================================================= -->
  <!-- HEADER -->
  <!-- ========================================================= -->

  <div class="pl-header" *ngIf="!compacto">
    <div>
      <h1 class="pl-titulo">Gestão de Postos</h1>

      <span class="pl-sub">
        {{ totalRecords }}
        posto{{ totalRecords !== 1 ? "s" : "" }}
        registado{{ totalRecords !== 1 ? "s" : "" }}
      </span>
    </div>

    <div class="pl-header-actions">

      <button class="btn-secondary" (click)="toggleLayout()">
        <i class="fas" [ngClass]="
            isGridView
              ? 'fa-list'
              : 'fa-grip'
          "></i>

        {{ isGridView ? "Lista" : "Grade" }}
      </button>

      <button class="btn-secondary" (click)="showFilters = true">
        <i class="fas fa-sliders"></i>
        Filtros

        <span class="filter-dot" *ngIf="filtersActive">
          •
        </span>
      </button>

      <button class="btn-primary" (click)="_novoPosto()">
        <i class="fas fa-plus"></i>
        Novo Posto
      </button>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- TOOLBAR COMPACTO -->
  <!-- ========================================================= -->

  <div class="pl-toolbar-compacto" *ngIf="compacto">
    <span class="pl-count" *ngIf="totalRecords > 0">
      {{ totalRecords }}
      posto{{ totalRecords !== 1 ? "s" : "" }}
    </span>

    <div class="pl-toolbar-actions">

      <button class="btn-secondary btn-sm" (click)="showFilters = true">
        <i class="fas fa-sliders"></i>
        Filtros 

        <span class="filter-dot" *ngIf="filtersActive">
          •
        </span>
      </button>

      <button class="btn-primary btn-sm" (click)="_novoPosto()">
        <i class="fas fa-plus"></i>
        Novo Posto
      </button>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- KPIs — DADOS REAIS DA API -->
  <!-- ========================================================= -->

  <div class="kpi-grid mini" style="margin-bottom: 18px" *ngIf="!compacto">

    <!-- Total -->
    <div class="kpi-card mini">
      <div class="kpi-icon blue">
        <i class="fas fa-building-shield"></i>
      </div>

      <div class="kpi-info">
        <span>Total Postos</span>
        <strong>{{ totalPostos }}</strong>
      </div>
    </div>


    <!-- Ativos -->
    <div class="kpi-card mini">
      <div class="kpi-icon green">
        <i class="fas fa-check-circle"></i>
      </div>

      <div class="kpi-info">
        <span>Ativos</span>
        <strong>{{ ativos }}</strong>
      </div>
    </div>


    <!-- Sem Efetivo -->
    <div class="kpi-card mini">
      <div class="kpi-icon red">
        <i class="fas fa-user-slash"></i>
      </div>

      <div class="kpi-info">
        <span>Sem Efetivo</span>
        <strong>{{ semEfetivo }}</strong>
      </div>
    </div>


    <!-- Em Atenção -->
    <div class="kpi-card mini">
      <div class="kpi-icon yellow">
        <i class="fas fa-triangle-exclamation"></i>
      </div>

      <div class="kpi-info">
        <span>Em Atenção</span>
        <strong>{{ emAtencao }}</strong>
      </div>
    </div>


    <!-- Rondas Hoje -->
    <div class="kpi-card mini">
      <div class="kpi-icon purple">
        <i class="fas fa-rotate"></i>
      </div>

      <div class="kpi-info">
        <span>Rondas Hoje</span>
        <strong>{{ rondasHoje }}</strong>
      </div>
    </div>


    <!-- Ocorrências -->
    <div class="kpi-card mini">
      <div class="kpi-icon orange">
        <i class="fas fa-exclamation-triangle"></i>
      </div>

      <div class="kpi-info">
        <span>Ocorrências Abertas</span>
        <strong>{{ ocorrenciasAbertas }}</strong>
      </div>
    </div>

  </div>


  <!-- ========================================================= -->
  <!-- PESQUISA / FILTROS RÁPIDOS -->
  <!-- ========================================================= -->

  <div class="pl-search-filter-row">

    <div class="pl-search-wrapper">

      <i class="fas fa-search search-icon"></i>

      <input type="text" placeholder="Pesquisar posto, cliente, zona..." [(ngModel)]="filtroPesquisa"
        (ngModelChange)="onSearchChange()" class="pl-search-input" />

    </div>


    <div class="pl-filter-chips">

      <!-- Todos -->
      <button class="pl-chip" [class.active]="filtroEstadoRapido === 'todos'" (click)="clearFilters()">
        Todos

        <span class="pl-chip-count" *ngIf="totalRecords">
          {{ totalRecords }}
        </span>
      </button>


      <!-- Ativos -->
      <button class="pl-chip pl-chip--green" [class.active]="filtroEstadoRapido === 'ativos'"
        (click)="setFiltroEstadoRapido('ativos')">
        <span class="pl-chip-dot green"></span>
        Ativos
      </button>


      <!-- Atenção -->
      <button class="pl-chip pl-chip--yellow" [class.active]="filtroEstadoRapido === 'atencao'"
        (click)="setFiltroEstadoRapido('atencao')">
        <span class="pl-chip-dot yellow"></span>
        Atenção
      </button>


      <!-- Sem Efetivo -->
      <button class="pl-chip pl-chip--red" [class.active]="filtroEstadoRapido === 'semEfetivo'"
        (click)="setFiltroEstadoRapido('semEfetivo')">
        <span class="pl-chip-dot red"></span>
        Sem Efetivo
      </button>


      <!-- Inativos -->
      <button class="pl-chip pl-chip--grey" [class.active]="filtroEstadoRapido === 'inativos'"
        (click)="setFiltroEstadoRapido('inativos')">
        <span class="pl-chip-dot grey"></span>
        Inativos
      </button>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- CONTEXTO DO CLIENTE -->
  <!-- ========================================================= -->

  <div class="posto-client-banner" style="margin-bottom: 12px" *ngIf="!compacto && clienteSelecionado">

    <div class="pcb-inner">

      <div class="pcb-avatar">
        {{
        clienteSelecionado.nome
        .substring(0, 2)
        .toUpperCase()
        }}
      </div>

      <div class="pcb-info">

        <strong>
          {{ clienteSelecionado.nome }}
        </strong>

        <span>

          {{ totalRecords }}
          posto{{ totalRecords !== 1 ? "s" : "" }}

          <span *ngIf="contratoSelecionado">
            · Contrato #{{ contratoSelecionado.id }}
          </span>

          <span *ngIf="
              clienteSelecionado.createdAt ||
              contratoSelecionado?.inicioContrato
            ">
            · desde
            {{
            formatDate(
            clienteSelecionado.createdAt ||
            contratoSelecionado?.inicioContrato
            )
            }}
          </span>

        </span>

      </div>

    </div>


    <button class="pcb-clear" (click)="onClienteFilterChange('all')" title="Limpar filtro de cliente">
      <i class="fas fa-times"></i>
      Ver todos
    </button>

  </div>


  <!-- ========================================================= -->
  <!-- LOADING -->
  <!-- ========================================================= -->

  <div *ngIf="loading" class="pl-skeleton-grid">

    <p-skeleton *ngFor="
        let i of [
          1,
          2,
          3,
          4,
          5,
          6
        ]
      " height="300px" borderRadius="16px"></p-skeleton>

  </div>


  <!-- ========================================================= -->
  <!-- MAPA -->
  <!-- ========================================================= -->

  <app-mapa-geral *ngIf="!loading" [postos]="postos" [height]="mapaHeight" [showCriarBtn]="false"
    (verPosto)="_verPosto($event)" (editarPosto)="_editarPosto($event)" (criarPosto)="_novoPosto()">

    <div slot="tabela">

      <!-- ===================================================== -->
      <!-- GRID -->
      <!-- ===================================================== -->

      <div class="pl-grid" [class.pl-layout-list]="!isGridView" *ngIf="postos.length > 0">

        <div class="posto-card-rich" *ngFor="let p of postos" [class.green]="
            p.ativo &&
            (p.numEfetivosTurno ?? 0) > 0 &&
            p.risco !== 'Alto' &&
            p.risco !== 'Critico' &&
            p.risco !== 'Crítico'
          " [class.yellow]="
            p.ativo &&
            (p.numEfetivosTurno ?? 0) > 0 &&
            (
              p.risco === 'Alto' ||
              p.risco === 'Critico' ||
              p.risco === 'Crítico'
            )
          " [class.red]="
            p.ativo &&
            !(p.numEfetivosTurno ?? 0)
          " [class.grey]="!p.ativo" (click)="_verPosto(p)">

          <!-- ================================================= -->
          <!-- HEADER DO POSTO -->
          <!-- ================================================= -->

          <div class="pcr-header">

            <div class="pcr-status-dot" [class.green]="
                p.ativo &&
                (p.numEfetivosTurno ?? 0) > 0 &&
                p.risco !== 'Alto' &&
                p.risco !== 'Critico' &&
                p.risco !== 'Crítico'
              " [class.yellow]="
                p.ativo &&
                (p.numEfetivosTurno ?? 0) > 0 &&
                (
                  p.risco === 'Alto' ||
                  p.risco === 'Critico' ||
                  p.risco === 'Crítico'
                )
              " [class.red]="
                p.ativo &&
                !(p.numEfetivosTurno ?? 0)
              " [class.grey]="!p.ativo"></div>


            <div class="pcr-title-block">

              <h4>
                {{ p.nome }}
              </h4>

              <span class="pcr-client" *ngIf="
                  p.nomeCliente &&
                  !idCliente
                ">
                {{ p.nomeCliente }}
              </span>

            </div>


            <!-- Estado -->
            <span class="pcr-badge" [class.green]="
                p.ativo &&
                (p.numEfetivosTurno ?? 0) > 0 &&
                p.risco !== 'Alto' &&
                p.risco !== 'Critico' &&
                p.risco !== 'Crítico'
              " [class.yellow]="
                p.ativo &&
                (p.numEfetivosTurno ?? 0) > 0 &&
                (
                  p.risco === 'Alto' ||
                  p.risco === 'Critico' ||
                  p.risco === 'Crítico'
                )
              " [class.red]="
                p.ativo &&
                !(p.numEfetivosTurno ?? 0)
              " [class.grey]="!p.ativo">

              {{
              !p.ativo
              ? "Inativo"
              : !(p.numEfetivosTurno ?? 0)
              ? "Sem Efetivo"
              : (
              p.risco === "Alto" ||
              p.risco === "Critico" ||
              p.risco === "Crítico"
              )
              ? "Atenção"
              : "Ativo"
              }}

            </span>


          </div>


          <!-- ================================================= -->
          <!-- META -->
          <!-- ================================================= -->

          <div class="pcr-meta">

            <div class="pcr-meta-item" *ngIf="
                p.nomeMunicipio ||
                p.nomeProvincia
              ">
              <i class="fas fa-map-marker-alt"></i>

              <span>
                {{ p.nomeMunicipio }}

                {{
                p.nomeMunicipio &&
                p.nomeProvincia
                ? ", "
                : ""
                }}

                {{ p.nomeProvincia }}
              </span>
            </div>


            <div class="pcr-meta-item" *ngIf="p.nomeTipoPosto">
              <i class="fas fa-building-shield"></i>
              <span>
                {{ p.nomeTipoPosto }}
              </span>
            </div>


            <div class="pcr-meta-item" *ngIf="p.risco">
              <i class="fas fa-shield-halved"></i>

              <span>
                {{ p.risco }}
              </span>
            </div>


            <div class="pcr-meta-item" *ngIf="p.codigo">
              <i class="fas fa-hashtag"></i>

              <span>
                {{ p.codigo }}
              </span>
            </div>

          </div>


          <!-- ================================================= -->
          <!-- KPIs DO POSTO -->
          <!-- ================================================= -->

          <div class="pcr-kpis">

            <div class="pcr-kpi">
              <i class="fas fa-users" style="color: #3b82f6"></i>

              <strong>
                {{ p.numEfetivosTurno ?? 0 }}
              </strong>

              <span>
                Ef./Turno
              </span>
            </div>


            <div class="pcr-kpi">
              <i class="fas fa-rotate" style="color: #22c55e"></i>

              <strong>
                {{ p.numTurnosDia ?? 0 }}
              </strong>

              <span>
                Turnos/Dia
              </span>
            </div>


            <div class="pcr-kpi">
              <i class="fas fa-route" style="color: #f59e0b"></i>

              <strong>
                {{ p.rondasHoje?.length || 0 }}
              </strong>

              <span>
                Rondas
              </span>
            </div>


            <div class="pcr-kpi">
              <i class="fas fa-triangle-exclamation" style="color: #ef4444"></i>

              <strong>
                {{ p.totalOcorrencias ?? 0 }}
              </strong>

              <span>
                Ocorrências
              </span>
            </div>

          </div>


          <!-- ================================================= -->
          <!-- SEM EFETIVO -->
          <!-- ================================================= -->

          <div class="pcr-alert-banner" *ngIf="
              p.ativo &&
              !(p.numEfetivosTurno ?? 0)
            ">
            <i class="fas fa-triangle-exclamation"></i>

            <span>
              Sem efetivos escalados neste turno
            </span>
          </div>


          <!-- ================================================= -->
          <!-- EQUIPA -->
          <!-- ================================================= -->

          <div class="pcr-shift-info" *ngIf="p.ativo">

            <div class="pcr-shift-header">

              <small class="pcr-shift-desc">
                <i class="fas fa-user-shield"></i>
                Equipa de hoje
              </small>

              <span class="team-coverage-count" [class.incomplete]="
                  (p.efetivosEmServico?.length || 0) <
                  (p.numEfetivosTurno || 0)
                ">
                {{ p.efetivosEmServico?.length || 0 }}
                /
                {{ p.numEfetivosTurno || 0 }}
              </span>

            </div>


            <!-- Equipa disponível -->
            <button type="button" class="team-preview" *ngIf="
                p.efetivosEmServico &&
                p.efetivosEmServico.length > 0;
                else noGuards
              " (click)="
                abrirEquipaDrawer($event, p)
              " [attr.aria-label]="
                'Ver equipa escalada de ' +
                p.nome
              ">

              <span class="team-preview-avatar" [ngClass]="
                  getGuardaColorClassFromName(
                    p.efetivosEmServico[0].nome
                  )
                ">

                {{
                getGuardaInitialsFromName(
                p.efetivosEmServico[0].nome
                )
                }}

                <i [class.online]="
                    p.efetivosEmServico[0]
                      .estaEmServico
                  "></i>

              </span>


              <span class="team-preview-copy">

                <span class="team-preview-name">

                  <strong>
                    {{
                    p.efetivosEmServico[0]
                    .nome
                    }}
                  </strong>

                  <small>
                    G-{{
                    (
                    "0000" +
                    p.efetivosEmServico[0]
                    .efetivoId
                    ).slice(-4)
                    }}
                  </small>

                </span>


                <span class="team-preview-meta">

                  <b>
                    <i [class]="
                        p.efetivosEmServico[0]
                          .turnoIcon ||
                        'pi pi-clock'
                      "></i>

                    {{
                    p.efetivosEmServico[0]
                    .turnoDescricao ||
                    'Turno'
                    }}
                  </b>

                  <em>
                    {{
                    formatEscalaHorario(
                    p.efetivosEmServico[0]
                    .escalaHoraInicioReal,

                    p.efetivosEmServico[0]
                    .escalaHoraFimReal
                    )
                    }}
                  </em>

                </span>

              </span>


              <span class="team-preview-more" *ngIf="
                  p.efetivosEmServico.length > 1
                ">
                +
                {{
                p.efetivosEmServico.length - 1
                }}
              </span>


              <span class="team-preview-open">
                <i class="fas fa-chevron-right"></i>
              </span>

            </button>


            <!-- Sem equipa -->
            <ng-template #noGuards>

              <button type="button" class="pcr-no-guards" (click)="
                  openGerirEscala(p);
                  $event.stopPropagation()
                ">

                <span class="pcr-no-guards-icon">
                  <i class="fas fa-user-plus"></i>
                </span>


                <span class="pcr-no-guards-copy">

                  <strong>
                    Equipa por escalar
                  </strong>

                  <span>
                    Adicione efetivos para garantir
                    a cobertura
                  </span>

                </span>


                <span class="empty-team-action">
                  <i class="fas fa-plus"></i>
                </span>

              </button>

            </ng-template>


            <!-- Cobertura incompleta -->
            <div class="pcr-staff-warning" *ngIf="
                p.ativo &&
                (p.efetivosEmServico?.length || 0) <
                (p.numEfetivosTurno || 0)
              ">

              <i class="fas fa-shield-exclamation"></i>

              <span>

                Faltam

                <strong>
                  {{
                  (p.numEfetivosTurno || 0) -
                  (p.efetivosEmServico?.length || 0)
                  }}
                </strong>

                para completar a cobertura

              </span>

              <button type="button" (click)="
                  openGerirEscala(p);
                  $event.stopPropagation()
                ">
                Completar
              </button>

            </div>

          </div>


          <!-- ================================================= -->
          <!-- POSTO EM ATENÇÃO -->
          <!-- ================================================= -->

          <div class="pcr-alert-banner" *ngIf="
              p.ativo &&
              (
                p.risco === 'Alto' ||
                p.risco === 'Critico' ||
                p.risco === 'Crítico'
              )
            ">

            <i class="fas fa-triangle-exclamation"></i>

            <span>

              <strong>
                Posto em Atenção
              </strong>

              — Nível de risco
              {{ p.risco }}

            </span>

          </div>


          <!-- ================================================= -->
          <!-- AÇÕES -->
          <!-- ================================================= -->

          <div class="pcr-actions" (click)="$event.stopPropagation()">

            <button class="btn-pcr-action pcr-blue" (click)="openHistorico(p)">
              <i class="fas fa-history"></i>
              Histórico
            </button>


            <button class="btn-pcr-action pcr-green" (click)="openGerir(p)">
              <i class="fas fa-sliders"></i>
              Gerir
            </button>


            <button class="btn-pcr-action pcr-grey" (click)="_editarPosto(p)">
              <i class="fas fa-pen"></i>
              Editar
            </button>

          </div>

        </div>

      </div>


      <!-- ===================================================== -->
      <!-- EMPTY STATE -->
      <!-- ===================================================== -->

      <app-empty-state *ngIf="postos.length === 0" icon="ri-map-pin-line" title="Nenhum posto registado" [message]="
          idCliente
            ? 'Este cliente não tem postos associados.'
            : 'Crie o primeiro posto de segurança.'
        " actionLabel="Novo Posto" (action)="_novoPosto()">
      </app-empty-state>


      <!-- ===================================================== -->
      <!-- PAGINAÇÃO -->
      <!-- ===================================================== -->

      <p-paginator *ngIf="totalRecords > pageSize" [rows]="pageSize" [totalRecords]="totalRecords" [rowsPerPageOptions]="[
          12,
          24,
          48
        ]" [first]="
          (page - 1) * pageSize
        " (onPageChange)="
          onPageChange($event)
        " styleClass="sp-paginator" style="margin-top: 16px">
      </p-paginator>

    </div>

  </app-mapa-geral>


  <!-- ========================================================= -->
  <!-- DRAWER DA EQUIPA -->
  <!-- ========================================================= -->

  <p-drawer [(visible)]="equipaDrawerVisible" position="right" [modal]="true" appendTo="body" [style]="{
      width: '460px',
      maxWidth: '96vw'
    }" styleClass="team-roster-drawer">

    <ng-template pTemplate="header">

      <div class="team-drawer-title">

        <span>
          <i class="fas fa-users-viewfinder"></i>
        </span>

        <div>

          <small>
            EQUIPA OPERACIONAL
          </small>

          <h2>
            {{ equipaDrawerPosto?.nome }}
          </h2>

        </div>

      </div>

    </ng-template>


    <ng-container *ngIf="
        equipaDrawerPosto as teamPosto
      ">

      <div class="team-drawer-body">

        <!-- Cobertura -->
        <section class="team-coverage-hero">

          <div class="coverage-ring" [style.--coverage]="
              coberturaEquipaPercentagem + '%'
            ">
            <strong>
              {{ coberturaEquipaPercentagem }}%
            </strong>
          </div>


          <div class="coverage-copy">

            <small>
              COBERTURA DO TURNO
            </small>

            <strong>

              {{
              teamPosto
              .efetivosEmServico
              ?.length || 0
              }}

              de

              {{
              teamPosto
              .numEfetivosTurno || 0
              }}

              efetivos

            </strong>


            <span [class.complete]="
                coberturaEquipaPercentagem >= 100
              ">

              <i [class]="
                  coberturaEquipaPercentagem >= 100
                    ? 'fas fa-circle-check'
                    : 'fas fa-triangle-exclamation'
                "></i>

              {{
              coberturaEquipaPercentagem >= 100
              ? 'Cobertura assegurada'
              : 'Cobertura incompleta'
              }}

            </span>

          </div>


          <div class="coverage-post-code">

            <small>
              POSTO
            </small>

            <strong>
              {{ teamPosto.codigo || '--' }}
            </strong>

          </div>

        </section>


        <!-- Cabeçalho da escala -->
        <div class="team-drawer-section-head">

          <div>

            <small>
              ESCALA DE HOJE
            </small>

            <strong>
              Efetivos selecionados
            </strong>

          </div>

          <span>
            {{
            teamPosto
            .efetivosEmServico
            ?.length || 0
            }}
          </span>

        </div>


        <!-- Lista de efetivos -->
        <div class="team-roster-list" *ngIf="
            teamPosto.efetivosEmServico?.length;
            else drawerEmptyTeam
          ">

          <article *ngFor="
              let ef of teamPosto.efetivosEmServico;
              let i = index;
              trackBy: trackEfetivoEmServico
            " class="team-roster-item">

            <span class="roster-order">
              {{
              (i + 1)
              .toString()
              .padStart(2, '0')
              }}
            </span>


            <span class="roster-avatar" [ngClass]="
                getGuardaColorClassFromName(
                  ef.nome
                )
              ">

              {{
              getGuardaInitialsFromName(
              ef.nome
              )
              }}

              <i [class.online]="
                  ef.estaEmServico
                "></i>

            </span>


            <div class="roster-main">

              <div class="roster-name-row">

                <strong>
                  {{ ef.nome }}
                </strong>

                <span [class.active]="
                    ef.estaEmServico
                  ">
                  {{
                  ef.estaEmServico
                  ? 'Em serviço'
                  : 'Escalado'
                  }}
                </span>

              </div>


              <small>
                G-{{
                (
                "0000" +
                ef.efetivoId
                ).slice(-4)
                }}
              </small>


              <div class="roster-shift-row">

                <b>

                  <i [class]="
                      ef.turnoIcon ||
                      'pi pi-clock'
                    "></i>

                  {{
                  ef.turnoDescricao ||
                  'Turno'
                  }}

                </b>


                <em>

                  <i class="fas fa-clock"></i>

                  {{
                  formatEscalaHorario(
                  ef.escalaHoraInicioReal,
                  ef.escalaHoraFimReal
                  )
                  }}

                </em>

              </div>


              <div class="roster-period">

                <i class="fas fa-calendar-day"></i>

                {{
                formatEscalaPeriodo(
                ef.escalaHoraInicioReal,
                ef.escalaHoraFimReal
                )
                }}

              </div>

            </div>

          </article>

        </div>


        <!-- Equipa vazia -->
        <ng-template #drawerEmptyTeam>

          <div class="team-drawer-empty">

            <span>
              <i class="fas fa-user-plus"></i>
            </span>

            <strong>
              A equipa ainda não foi escalada
            </strong>

            <p>
              Adicione efetivos para assegurar
              a operação deste posto hoje.
            </p>

          </div>

        </ng-template>

      </div>


      <!-- Footer -->
      <div class="team-drawer-footer">

        <button type="button" class="drawer-close-btn" (click)="
            fecharEquipaDrawer()
          ">
          Fechar
        </button>


        <button type="button" class="drawer-manage-btn" (click)="
            openGerirEscala(teamPosto)
          ">
          <i class="fas fa-sliders"></i>
          Gerir escala
        </button>

      </div>

    </ng-container>

  </p-drawer>


  <!-- ========================================================= -->
  <!-- PAINEL DE FILTROS -->
  <!-- ========================================================= -->

  <app-filter-panel [(visible)]="showFilters" title="Filtros de Posto" (applyFilters)="applyFilters()"
    (clearFilters)="clearDrawerFilters()">

    <!-- Pesquisa -->
    <div class="sp-form-group">

      <label>
        Pesquisar
      </label>

      <div class="sp-filter-search">

        <i class="fas fa-search"></i>

        <input type="text" [(ngModel)]="filtroPesquisa" (input)="load()" placeholder="Posto, cliente, zona..." />

      </div>

    </div>


    <!-- Cliente -->
    <div class="sp-form-group" *ngIf="!idClienteFixo">

      <label>
        Cliente
      </label>

      <p-select [ngModel]="idCliente" (ngModelChange)="
          onClienteFilterChange($event)
        " [options]="clientes" optionLabel="nome" optionValue="id" placeholder="Todos os clientes" [showClear]="true"
        styleClass="w-full" panelStyleClass="postos-clientes-filter-overlay">
      </p-select>

    </div>


    <!-- Código / Designação -->
    <div class="sp-filter-grid-2">

      <div class="sp-form-group">

        <label>
          Código
        </label>

        <input class="sp-input" [(ngModel)]="filtroCodigo" placeholder="PST-001" />

      </div>


      <div class="sp-form-group">

        <label>
          Designação
        </label>

        <input class="sp-input" [(ngModel)]="filtroNome" placeholder="Nome do posto..." />

      </div>

    </div>


    <!-- Endereço -->
    <div class="sp-form-group" style="margin-top: 12px">

      <label>
        Endereço
      </label>

      <input class="sp-input" [(ngModel)]="filtroEndereco" placeholder="Rua, bairro..." />

    </div>


    <!-- Tipo / Risco -->
    <div class="sp-filter-grid-2" style="margin-top: 12px">

      <div class="sp-form-group">

        <label>
          Tipo de Posto
        </label>

        <p-select [(ngModel)]="filtroTipoPosto" [options]="tiposPosto" optionLabel="designacao" optionValue="id"
          placeholder="Todos" [showClear]="true" styleClass="w-full" appendTo="body">
        </p-select>

      </div>


      <div class="sp-form-group">

        <label>
          Nível de Risco
        </label>

        <p-select [(ngModel)]="filtroRisco" [options]="riscoOpcoes" optionLabel="label" optionValue="value"
          placeholder="Todos" [showClear]="true" styleClass="w-full" appendTo="body">
        </p-select>

      </div>

    </div>


    <!-- Efetivos / Turnos -->
    <div class="sp-filter-grid-2" style="margin-top: 12px">

      <div class="sp-form-group">

        <label>
          Ef./Turno
        </label>

        <p-inputnumber [(ngModel)]="filtroNumEfetivos" [min]="1" [showClear]="true" placeholder="Ex: 2"
          styleClass="w-full">
        </p-inputnumber>

      </div>


      <div class="sp-form-group">

        <label>
          Turnos/Dia
        </label>

        <p-inputnumber [(ngModel)]="filtroNumTurnos" [min]="1" [showClear]="true" placeholder="Ex: 3"
          styleClass="w-full">
        </p-inputnumber>

      </div>

    </div>


    <!-- Estado -->
    <div class="sp-form-group" style="margin-top: 12px">

      <label>
        Estado
      </label>

      <p-select [(ngModel)]="filtroAtivo" [options]="ativoOpcoes" optionLabel="label" optionValue="value"
        placeholder="Todos os estados" [showClear]="true" styleClass="w-full" appendTo="body">
      </p-select>

    </div>

  </app-filter-panel>

</div>

<!-- ── MODAL HISTÓRICO DO POSTO ── -->
<p-dialog [(visible)]="mostrarModalHistorico" [modal]="true" [style]="{ width: 'min(94vw, 860px)', maxWidth: '860px' }"
  [draggable]="false" [resizable]="false" [closable]="false" [dismissableMask]="true"
  styleClass="modal-historico-posto-dialog" appendTo="body" (onHide)="fecharModalHistorico()">

  <!-- ── CABEÇALHO PERSONALIZADO DA MODAL COM TABS E BOTÕES DE AÇÃO ── -->
  <ng-template pTemplate="header">
    <div class="modal-historico-header-wrapper">
      <div class="modal-historico-header-custom">
        <div class="header-title-block">
          <div class="title-with-badge">
            <h3>Histórico do Posto — {{ estatisticasPostoData?.nomePosto || postoHistoricoSelecionado?.nome || '' }}
            </h3>
            <span class="header-post-code"
              *ngIf="estatisticasPostoData?.codigoPosto || postoHistoricoSelecionado?.codigo">
              #{{ estatisticasPostoData?.codigoPosto || postoHistoricoSelecionado?.codigo }}
            </span>
            <span class="header-post-type" *ngIf="estatisticasPostoData?.tipoPostoNome">
              {{ estatisticasPostoData.tipoPostoNome }}
            </span>
          </div>

          <div class="header-submeta">
            <span class="header-client-name"
              *ngIf="estatisticasPostoData?.clienteNome || postoHistoricoSelecionado?.clienteNome">
              <i class="pi pi-building"></i> {{ estatisticasPostoData?.clienteNome ||
              postoHistoricoSelecionado?.clienteNome }}
            </span>
            <span class="header-location"
              *ngIf="estatisticasPostoData?.localizacao || postoHistoricoSelecionado?.endereco">
              <i class="ri-map-pin-line"></i> {{ estatisticasPostoData?.localizacao ||
              postoHistoricoSelecionado?.endereco
              }}
            </span>
            <span class="header-contract-val" *ngIf="estatisticasPostoData?.contratoAtual?.valorMensal">
              <i class="ri-file-list-3-line"></i> Contrato: {{
              formatarKz(estatisticasPostoData.contratoAtual.valorMensal)
              }}/mês
            </span>
          </div>
        </div>

        <div class="header-action-buttons">
          <button type="button" class="btn-export-pdf" (click)="exportarHistoricoPdf()"
            pTooltip="Exportar Histórico em PDF" tooltipPosition="bottom">
            <i class="ri-file-pdf-2-line"></i>
            <span>Exportar PDF</span>
          </button>
          <button type="button" class="btn-modal-close" (click)="fecharModalHistorico()" pTooltip="Fechar modal"
            tooltipPosition="bottom">
            <i class="ri-close-line"></i>
            <span>Fechar</span>
          </button>
        </div>
      </div>

      <!-- ── BARRA DE TABS NAVEGAÇÃO DO MODAL (TIMELINE, OCORRÊNCIAS, TURNOS, RONDAS, EFETIVOS) ── -->
      <div class="modal-historico-nav-tabs">
        <button type="button" class="modal-nav-tab" [class.active]="abaAtivaModalHistorico === 'timeline'"
          (click)="abaAtivaModalHistorico = 'timeline'">
          <i class="ri-menu-line"></i>
          <span>Timeline</span>
        </button>
        <button type="button" class="modal-nav-tab" [class.active]="abaAtivaModalHistorico === 'ocorrencias'"
          (click)="abaAtivaModalHistorico = 'ocorrencias'; selecionarTipoEventoTimeline(2)">
          <i class="ri-alarm-warning-line"></i>
          <span>Ocorrências</span>
          <span class="tab-count" *ngIf="countOcorrencias > 0">{{ countOcorrencias }}</span>
        </button>
        <button type="button" class="modal-nav-tab" [class.active]="abaAtivaModalHistorico === 'turnos'"
          (click)="abaAtivaModalHistorico = 'turnos'; selecionarTipoEventoTimeline(3)">
          <i class="ri-time-line"></i>
          <span>Turnos</span>
          <span class="tab-count" *ngIf="countTurnos > 0">{{ countTurnos }}</span>
        </button>
        <button type="button" class="modal-nav-tab" [class.active]="abaAtivaModalHistorico === 'rondas'"
          (click)="abaAtivaModalHistorico = 'rondas'; selecionarTipoEventoTimeline(1)">
          <i class="ri-repeat-line"></i>
          <span>Rondas</span>
          <span class="tab-count" *ngIf="countRondas > 0">{{ countRondas }}</span>
        </button>
        <button type="button" class="modal-nav-tab" [class.active]="abaAtivaModalHistorico === 'efetivos'"
          (click)="abaAtivaModalHistorico = 'efetivos'">
          <i class="ri-group-line"></i>
          <span>Efetivos</span>
        </button>
      </div>
    </div>
  </ng-template>

  <div class="modal-historico-body">
    <!-- ── 6 CARDS DE MÉTRICAS-RESUMO (FIXO NO CABEÇALHO DA MODAL) ── -->
    <div class="historico-kpis-grid" *ngIf="postoHistoricoSelecionado">
      <!-- Card 1: Rondas no Período -->
      <div class="kpi-card green">
        <div class="kpi-icon-wrap">
          <i class="ri-route-line"></i>
        </div>
        <div class="kpi-info">
          <span class="kpi-value">{{ metricasHistorico.rondasEsteMes }}</span>
          <span class="kpi-label">Rondas no período</span>
        </div>
      </div>

      <!-- Card 2: Ocorrências -->
      <div class="kpi-card red">
        <div class="kpi-icon-wrap">
          <i class="ri-alarm-warning-line"></i>
        </div>
        <div class="kpi-info">
          <span class="kpi-value">{{ metricasHistorico.ocorrencias }}</span>
          <span class="kpi-label">Ocorrências</span>
        </div>
      </div>

      <!-- Card 3: Turnos cumpridos -->
      <div class="kpi-card blue">
        <div class="kpi-icon-wrap">
          <i class="ri-time-line"></i>
        </div>
        <div class="kpi-info">
          <span class="kpi-value">{{ metricasHistorico.turnosCumpridos }}</span>
          <span class="kpi-label">Turnos cumpridos</span>
        </div>
      </div>

      <!-- Card 4: Horas de serviço -->
      <div class="kpi-card purple">
        <div class="kpi-icon-wrap">
          <i class="ri-timer-flash-line"></i>
        </div>
        <div class="kpi-info">
          <span class="kpi-value">{{ metricasHistorico.horasServico }}</span>
          <span class="kpi-label">Horas de serviço</span>
        </div>
      </div>

      <!-- Card 5: Avaliação média -->
      <div class="kpi-card yellow">
        <div class="kpi-icon-wrap">
          <i class="ri-star-fill"></i>
        </div>
        <div class="kpi-info">
          <span class="kpi-value">{{ metricasHistorico.avaliacaoMedia }}</span>
          <span class="kpi-label">Avaliação média</span>
        </div>
      </div>

      <!-- Card 6: Fotos enviadas -->
      <div class="kpi-card cyan">
        <div class="kpi-icon-wrap">
          <i class="ri-camera-3-line"></i>
        </div>
        <div class="kpi-info">
          <span class="kpi-value">{{ metricasHistorico.fotosEnviadas }}</span>
          <span class="kpi-label">Fotos enviadas</span>
        </div>
      </div>
    </div>

    <!-- ── BARRA DE CONTROLO E FILTROS DA TIMELINE (EXIBIDO NA ABA TIMELINE) ── -->
    <div class="timeline-controls-bar" *ngIf="abaAtivaModalHistorico === 'timeline'">
      <!-- Filtro por Atalho de Período (Enum) -->
      <div class="timeline-period-group">
        <p-select [options]="opcoesAtalhoPeriodo" [(ngModel)]="filtroAtalhoTimeline"
          (onChange)="onAtalhoTimelineChange($event.value)" optionLabel="label" optionValue="value"
          styleClass="timeline-period-select"></p-select>
      </div>

      <!-- Datas Personalizadas (Exibido quando atalho === 4) -->
      <div class="timeline-custom-dates" *ngIf="filtroAtalhoTimeline === 4">
        <div class="date-field">
          <label><i class="ri-calendar-line"></i> Início:</label>
          <input type="date" class="sp-date-input" [(ngModel)]="filtroDataInicioTimeline"
            (change)="onDatasCustomTimelineChange()" />
        </div>
        <div class="date-field">
          <label><i class="ri-calendar-check-line"></i> Fim:</label>
          <input type="date" class="sp-date-input" [(ngModel)]="filtroDataFimTimeline"
            (change)="onDatasCustomTimelineChange()" />
        </div>
      </div>

      <!-- Filtros por Tipo de Evento (Chips) -->
      <div class="timeline-type-chips">
        <button type="button" class="tl-chip" [class.active]="filtroTipoEventoTimeline === 0"
          (click)="selecionarTipoEventoTimeline(0)">
          <span>Todos</span>
        </button>

        <button type="button" class="tl-chip blue-chip" [class.active]="filtroTipoEventoTimeline === 1"
          (click)="selecionarTipoEventoTimeline(1)">
          <i class="ri-refresh-line"></i>
          <span>Rondas</span>
        </button>

        <button type="button" class="tl-chip red-chip" [class.active]="filtroTipoEventoTimeline === 2"
          (click)="selecionarTipoEventoTimeline(2)">
          <i class="ri-alarm-warning-line"></i>
          <span>Ocorrências</span>
        </button>

        <button type="button" class="tl-chip orange-chip" [class.active]="filtroTipoEventoTimeline === 3"
          (click)="selecionarTipoEventoTimeline(3)">
          <i class="ri-flashlight-line"></i>
          <span>Turnos</span>
        </button>

        <button type="button" class="tl-chip grey-chip" [class.active]="filtroTipoEventoTimeline === 4"
          (click)="selecionarTipoEventoTimeline(4)">
          <i class="ri-tools-line"></i>
          <span>Equipamento</span>
        </button>
      </div>
    </div>

    <!-- ── SKELETON LOADER DA TIMELINE ── -->
    <div *ngIf="loadingHistorico" class="timeline-skeleton-list">
      <p-skeleton *ngFor="let item of [1, 2, 3, 4, 5]" height="64px" borderRadius="8px" styleClass="mb-2"></p-skeleton>
    </div>

    <!-- ── FEED CRONOLÓGICO DA TIMELINE (LAYOUT PROTÓTIPO EXACTO) ── -->
    <div *ngIf="!loadingHistorico && abaAtivaModalHistorico === 'timeline'" class="proto-timeline-feed">
      <ng-container *ngIf="timelineEventosFiltrados.length > 0">
        <div class="proto-tl-row" *ngFor="let item of timelineEventosFiltrados">
          <span class="proto-status-dot" [ngClass]="item.statusColor"></span>
          <div class="proto-tl-content">
            <div class="proto-tl-title">
              <i [class]="item.icon"></i>
              <span>{{ item.titulo }}</span>
            </div>
            <div class="proto-tl-detail">
              {{ item.detalhe }}
            </div>
          </div>
          <div class="proto-tl-time">
            {{ formatarDataTimelineCurta(item.data) }}
          </div>
        </div>
      </ng-container>

      <div *ngIf="timelineEventosFiltrados.length === 0" class="timeline-empty-feed">
        <div class="empty-icon-box">
          <i class="ri-history-line"></i>
        </div>
        <h4>Nenhum evento registado</h4>
        <p>Ainda não foram encontrados eventos para o tipo e período selecionados neste posto.</p>
      </div>
    </div>

    <!-- ── OUTRAS TABS (OCORRÊNCIAS, TURNOS, RONDAS, EFETIVOS) ── -->
    <div *ngIf="!loadingHistorico && abaAtivaModalHistorico !== 'timeline'" class="tab-content-container">
      <div class="proto-timeline-feed">
        <div class="proto-tl-row" *ngFor="let item of timelineEventosFiltrados">
          <span class="proto-status-dot" [ngClass]="item.statusColor"></span>
          <div class="proto-tl-content">
            <div class="proto-tl-title">
              <i [class]="item.icon"></i>
              <span>{{ item.titulo }}</span>
            </div>
            <div class="proto-tl-detail">
              {{ item.detalhe }}
            </div>
          </div>
          <div class="proto-tl-time">
            {{ formatarDataTimelineCurta(item.data) }}
          </div>
        </div>

        <div *ngIf="timelineEventosFiltrados.length === 0" class="timeline-empty-feed">
          <div class="empty-icon-box">
            <i class="ri-inbox-line"></i>
          </div>
          <h4>Nenhum registo encontrado</h4>
          <p>Não existem registos de {{ abaAtivaModalHistorico }} para este posto.</p>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="btn-web-secondary" (click)="fecharModalHistorico()">
      Fechar
    </button>
  </ng-template>
</p-dialog>
